'use client';

import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * This page's origin (`https://widgets.kalshi.com`), for copy-paste URLs and embed code. The
 * server render and hydration use `serverFallback`, so the two agree, and the client switches to
 * the real origin straight after without an effect.
 */
export function useOrigin(serverFallback: string): string {
    return useSyncExternalStore(
        subscribe,
        () => window.location.origin,
        () => serverFallback,
    );
}
